import { render } from "./App.vue?vue&type=template&id=f1b91e3c"
const script = {}

import "./App.vue?vue&type=style&index=0&id=f1b91e3c&lang=css"

import exportComponent from "D:\\SZK180142\\git-project\\officalm\\cignacmb-static\\cignacmb-m\\campaign\\bocomcc\\bwhyf\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__